Object.defineProperty(exports, "__esModule", {
  value: true,
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.apiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.apiMethodType = "GET";
exports.getMethod = "GET";
exports.postMethod = "POST";
exports.putMethod = "PUT";
exports.contentType = "application/json";
exports.tokenKey = "token";

exports.permanentTagsHeader = "Permanent Tags";
exports.tagCode = "Tag Code";
exports.productName = "Product Name";
exports.serviceName = "Service";
exports.status = "Status";

exports.permanentTagsListApi = "bx_block_permanent_tag/permanent_tags";
exports.tagCodeFilterSuggEndPoint = "bx_block_permanent_tag/permanent_tags/filter?tag_code=";
exports.customerUsageHistoryApi = "bx_block_permanent_tag/permanent_tags/customer_usage_history";

exports.noRecordFound = "No records found!!";
exports.popoverTestID = "popoverTest";
exports.back = "Back";
exports.cancel = "Cancel";
exports.add = "Add";
exports.save = "Save";
exports.edit = "Edit";
exports.deactivate = "Deactivate";
exports.deactivateContent = "Do you want to deactivate this Permanent Tag?";
exports.deactivateTitle = "Permanent Tag Deactivation";
// Customizable Area End
